var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AnalyticsTrigger } from '@telia-front/analytics';
import Button from '@telia-front/button';
import FormHelper from '@telia-front/form-helper';
import { useResponsiveProps } from '@telia-front/helper';
import { useLabels } from '@telia-front/label-provider';
const LargeSearch = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? React.createElement(LargeSearchResponsive, Object.assign({}, rest, { responsive: responsive })) : React.createElement(LargeSearchAnalytics, Object.assign({}, rest));
};
const LargeSearchResponsive = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const responsiveProps = useResponsiveProps({ responsive });
    return React.createElement(LargeSearchAnalytics, Object.assign({}, rest, responsiveProps));
};
const LargeSearchAnalytics = (props) => {
    return (React.createElement(AnalyticsTrigger, { trigger: {
            callback: 'onSubmit',
            id: `Search - Submit - ${props.id}`,
            elementId: props.id,
            elementType: 'search',
            interactionType: 'submit',
        } },
        React.createElement(LargeSearchInner, Object.assign({}, props))));
};
const LargeSearchInner = (props) => {
    const labels = useLabels();
    const { variant = 'light', align = 'center' } = props;
    const [hasButtonText, setHasButtonText] = React.useState(false);
    const [isFirstFieldFilled, setIsFirstFieldFilled] = React.useState(false);
    const BEM = () => {
        const classArray = ['large-search', `large-search--${variant}`, `large-search--${align}`];
        if (props.multiline || props.multilineConditional) {
            classArray.push('large-search--multiline');
        }
        if (props.multilineConditional) {
            classArray.push('large-search--multiline-conditional');
        }
        if (hasButtonText) {
            classArray.push('large-search--has-button-text');
        }
        if (isFirstFieldFilled) {
            classArray.push('is-dirty');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const getFields = (button) => {
        const children = React.Children.toArray(props.children).filter((React.isValidElement));
        const total = children.length;
        return children.map((child, index) => {
            const cloneProps = Object.assign(Object.assign(Object.assign({}, (index + 1 === total && { contentRenderer: () => button })), (props.multilineConditional &&
                index === 0 && {
                onChange: (value) => {
                    var _a, _b;
                    setIsFirstFieldFilled(!!value);
                    // @ts-expect-error type issue - select onChange does not always accept string value, but the functionality does not care
                    (_b = (_a = child.props) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
                },
            })), (props.multilineConditional && !isFirstFieldFilled && index > 0 && { isDisabled: true }));
            const clone = React.cloneElement(child, cloneProps);
            return (React.createElement("div", { key: index, className: "large-search__block" }, clone));
        });
    };
    const onSubmit = (event) => {
        var _a;
        props.onSubmit && props.onSubmit(event);
        ((_a = props.formAttributes) === null || _a === void 0 ? void 0 : _a.onSubmit) && props.formAttributes.onSubmit(event);
    };
    const getSubmit = () => {
        var _a, _b, _c, _d, _e, _f;
        const icon = !(((_a = props.submitButton) === null || _a === void 0 ? void 0 : _a.iconLeft) || ((_b = props.submitButton) === null || _b === void 0 ? void 0 : _b.iconRight)) ? '#search' : undefined;
        const type = (props === null || props === void 0 ? void 0 : props.type) || ((_c = props === null || props === void 0 ? void 0 : props.submitButton) === null || _c === void 0 ? void 0 : _c.type) || 'expressive';
        const text = (props === null || props === void 0 ? void 0 : props.submitButtonText) || ((_d = props === null || props === void 0 ? void 0 : props.submitButton) === null || _d === void 0 ? void 0 : _d.text) || labels.get('search.submit');
        if (!hasButtonText && (((_e = props.submitButton) === null || _e === void 0 ? void 0 : _e.iconLeft) || ((_f = props.submitButton) === null || _f === void 0 ? void 0 : _f.iconRight))) {
            setHasButtonText(true);
        }
        return (React.createElement(Button, Object.assign({ icon: icon, type: type, text: text }, props.submitButton, { className: "large-search__action", attributes: { type: 'submit' }, onClick: () => null })));
    };
    return (React.createElement("form", Object.assign({ className: BEM() }, props.formAttributes, { onSubmit: onSubmit, id: props.id }),
        React.createElement("div", { className: "large-search__inner" },
            React.createElement("div", { className: "large-search__fields" }, props.children && getFields(getSubmit())),
            !props.children && getSubmit()),
        !!props.helper && React.createElement(FormHelper, Object.assign({ className: "large-search__help" }, props.helper))));
};
export default LargeSearch;
